import { makeAutoObservable } from 'mobx';
import def from './def';

class Data {
	s = {
		def,
	};
	constructor(props) {
		makeAutoObservable(this);
	}
}

const data = new Data();
export default data;
